var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-layout', {
    staticClass: "text-center brown--text",
    attrs: {
      "column": "",
      "align-center": ""
    }
  }, [_c('h4', {
    staticClass: "tit tit--xs tit--underline mb-4 mb-md-6",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_c('span', [_vm._v("당첨을 축하드립니다!")])]), _c('v-sheet', {
    attrs: {
      "width": "792",
      "max-width": "100%",
      "data-aos": "fade-up",
      "data-aos-delay": _vm.$vuetify.breakpoint.mdAndUp ? 50 : 0
    }
  }, [_c('div', {
    staticClass: "winner-slide txt txt--sm txt txt--sm text-left brown--text"
  }, [_c('div', {
    staticClass: "swiper-container"
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, _vm._l(_vm.logs, function (log) {
    var _log$config, _log$config2, _log$user, _log$user2;

    return _c('div', {
      key: log._id,
      staticClass: "swiper-slide"
    }, [_c('v-layout', {
      staticClass: "winner-slide__inner",
      attrs: {
        "align-center": "",
        "fill-height": ""
      }
    }, [_c('div', {
      staticClass: "winner-slide__inner__col winner-slide__inner__col--image"
    }, [_c('img', {
      attrs: {
        "src": "".concat(log === null || log === void 0 ? void 0 : (_log$config = log.config) === null || _log$config === void 0 ? void 0 : _log$config.image)
      }
    })]), _c('div', {
      staticClass: "winner-slide__inner__col"
    }, [_c('p', {
      staticClass: "font-weight-bold"
    }, [_vm._v(" " + _vm._s(log === null || log === void 0 ? void 0 : (_log$config2 = log.config) === null || _log$config2 === void 0 ? void 0 : _log$config2.name) + " ")])]), _c('div', {
      staticClass: "winner-slide__inner__col"
    }, [_c('p', [_vm._v(" " + _vm._s(_vm.maskUsername(log === null || log === void 0 ? void 0 : (_log$user = log.user) === null || _log$user === void 0 ? void 0 : _log$user.username)) + " ")])]), _c('div', {
      staticClass: "winner-slide__inner__col"
    }, [_c('p', [_vm._v(" " + _vm._s(_vm.maskName(log === null || log === void 0 ? void 0 : (_log$user2 = log.user) === null || _log$user2 === void 0 ? void 0 : _log$user2.name)) + " ")])]), _c('div', {
      staticClass: "winner-slide__inner__col"
    }, [_c('p', [_vm._v(" " + _vm._s(_vm.$dayjs(log === null || log === void 0 ? void 0 : log.createdAt).format("MM/DD")) + " ")])])])], 1);
  }), 0)])])]), _c('v-sheet', {
    staticClass: "mt-4",
    attrs: {
      "width": "792",
      "max-width": "100%",
      "data-aos": "fade-up",
      "data-aos-delay": _vm.$vuetify.breakpoint.mdAndUp ? 50 : 0
    }
  }, [_c('div', {
    staticClass: "winner-slide txt txt--sm txt txt--sm text-left brown--text"
  }, [_c('div', {
    staticClass: "swiper-container"
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, _vm._l(_vm.ranking, function (log) {
    var _log$config3, _log$config4, _log$user3, _log$user4;

    return _c('div', {
      key: log._id,
      staticClass: "swiper-slide"
    }, [_c('v-layout', {
      staticClass: "winner-slide__inner",
      attrs: {
        "align-center": "",
        "fill-height": ""
      }
    }, [_c('div', {
      staticClass: "winner-slide__inner__col winner-slide__inner__col--image"
    }, [_c('img', {
      attrs: {
        "src": "".concat(log === null || log === void 0 ? void 0 : (_log$config3 = log.config) === null || _log$config3 === void 0 ? void 0 : _log$config3.image)
      }
    })]), _c('div', {
      staticClass: "winner-slide__inner__col"
    }, [_c('p', {
      staticClass: "font-weight-bold"
    }, [_vm._v(" " + _vm._s(log === null || log === void 0 ? void 0 : (_log$config4 = log.config) === null || _log$config4 === void 0 ? void 0 : _log$config4.name) + " ")])]), _c('div', {
      staticClass: "winner-slide__inner__col"
    }, [_c('p', [_vm._v(" " + _vm._s(_vm.maskUsername(log === null || log === void 0 ? void 0 : (_log$user3 = log.user) === null || _log$user3 === void 0 ? void 0 : _log$user3.username)) + " ")])]), _c('div', {
      staticClass: "winner-slide__inner__col"
    }, [_c('p', [_vm._v(" " + _vm._s(_vm.maskName(log === null || log === void 0 ? void 0 : (_log$user4 = log.user) === null || _log$user4 === void 0 ? void 0 : _log$user4.name)) + " ")])])])], 1);
  }), 0)])])])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }